export const NUMBER_SEQUENCE_RESET_PERIODS = [
  'daily',
  'monthly',
  'yearly',
  'never',
] as const

export type SequenceResetPeriod =
  (typeof NUMBER_SEQUENCE_RESET_PERIODS)[number]

export interface NumberSequence {
  id: string
  workspaceId: string
  moduleCode: string // e.g. 'sale', 'rider_sale', 'expense', 'receivable', 'SC', 'MD'
  name: string // e.g. 'Penjualan Toko / Kasir'
  prefix: string // Supports placeholders: %(Year)s, %(Y)s, %(Month)s, %(Day)s, %(ExtBranchId)s
  suffix: string // Optional suffix, supports placeholders
  size: number // Digit size / padding length (e.g. 4 -> 0001, 5 -> 00001)
  step: number // Increment step (default: 1)
  next: number // Next counter number (default: 1)
  resetPeriod: SequenceResetPeriod
  lastResetDate: string | null
  autoGenerateOnCreate: boolean
  createdAt: string
  updatedAt: string
}

export interface NumberSequenceSummary extends NumberSequence {
  nextPreview: string
}

export interface UpdateNumberSequenceReq {
  name?: string
  prefix?: string
  suffix?: string
  size?: number
  step?: number
  next?: number
  resetPeriod?: SequenceResetPeriod
  autoGenerateOnCreate?: boolean
}

export interface ResetNumberSequenceReq {
  nextNumber?: number
}
